export default __webpack_public_path__ + "static/media/solution_73.4c9ac542.svg";